<template>
  <el-dialog :title="$t(`channel.titles.${isAdd ? 'add' : 'editor'}`)" :visible.sync="dialogVisible" width="30%" @close="handleEmpty">
    <el-row>
      <el-form :model="form" v-bind="formRules">
        <el-form-item :label="$t('device.serialNumber')" prop="serialNumber">
          <el-input v-model="form.serialNumber"  />
        </el-form-item>
        <!--
        <el-form-item :label="$t('device.phone')" prop="phone">
          <el-input v-model="form.phone" />
        </el-form-item> -->
        <el-form-item :label="$t('device.bankAccount')" prop="bankAccount">
          <el-input v-model.trim="form.bankAccount"  :disabled="isdisable" />
        </el-form-item>
        <el-form-item :label="$t('device.bankCode')" prop="bankCode">
          <el-select v-model="form.bankCode">
            <el-option v-for="item in bankTransferCodes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.bankPayType')" prop="payType">
          <el-select v-model="form.payType">
            <el-option v-for="item in payTypeOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.bankName')" prop="bankName">
          <el-input v-model="form.bankName" />
        </el-form-item>
        <el-form-item :label="$t('device.owner_merchant_no')" prop="ownerMerchantNo">
          <el-select  v-model="form.ownerMerchantNo" filterable clearable multiple>
            <el-option v-for="item in merchantList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item :label="$t('device.minimumAmount')" prop="minimumAmount">
          <el-input v-model="form.minimumAmount" />
        </el-form-item>
         <el-form-item :label="$t('device.maximumAmount')" prop="maximumAmount">
          <el-input v-model="form.maximumAmount" />
        </el-form-item>
        <el-form-item :label="$t('device.payName')" prop="payName">
          <el-input v-model="form.payName" />
        </el-form-item>
        <el-form-item v-if="isAdd" :label="$t('device.loginAccount')" prop="loginAccount">
          <el-input v-model.trim="form.loginAccount"  :disabled="isdisable" />
        </el-form-item>
        <el-form-item :label="$t('accountmanager.userPass')" prop="password">
          <el-input v-model.trim="form.password" />
        </el-form-item>
        <el-form-item :label="$t('device.proQrStatus')" prop="proQrStatus">
          <el-select v-model="form.proQrStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.bankQrStatus')" prop="bankQrStatus">
          <el-select v-model="form.bankQrStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.momoBankStatus')" prop="momoBankStatus">
          <el-select v-model="form.momoBankStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item   :label="$t('device.zalobankStatus')"     prop="zaloBankStatus">
          <el-select v-model="form.zaloBankStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  :label="$t('device.vtpbankStatus')"    prop="vtpayBankStatus">
          <el-select v-model="form.vtpayBankStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.bankTransferStatus')" prop="bankTransferStatus">
          <el-select v-model="form.bankTransferStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.apiStatus')" prop="apiStatus">
          <el-select v-model="form.apiStatus">
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('device.balance')" prop="balance">
          <el-input v-model="form.balance" />
        </el-form-item>
        <el-form-item :label="$t('device.successTodayAmount')" prop="successTodayAmount">
          <el-input v-model="form.successTodayAmount" />
        </el-form-item> -->
        <el-form-item :label="$t('device.remark')" prop="remark">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item :label="$t('merchantdeposit.label.googleDynamicCaptcha')" prop="patchGoogleCode">
          <el-input v-model="form.patchGoogleCode" />
        </el-form-item>
        <!--        <el-form-item :label="$t('accountmanager.userPass')" prop="password">-->
        <!--          <el-input v-model="form.password" />-->
        <!--        </el-form-item>-->
        <!--        <el-form-item :label="$t('device.connectionStatus')" prop="connectionStatus">-->
        <!--          <el-select v-model="form.connectionStatus">-->
        <!--            <el-option v-for="item in connectionStatusOption" :key="item.value" :label="item.label" :value="item.value">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="warning" @click="handleEmpty()">{{
          $t("btns.empty")
        }}</el-button>
      <el-button size="mini" @click="handelCancel()">{{ $t("btns.cancel") }}</el-button>
      <el-button size="mini" type="primary" @click="handleEditor()">{{
          $t("btns.confirm")
        }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import channelApi from "@/api/channel";
import { debounce } from "lodash";

export default {
  props: ["statusData", "serviceTypes", "channelTypeList", "channelTypeData", "isZalo","isAdd","merchantList"],
  data() {
    return {
      dialogVisible: false,
      // isAdd: true,
      form: {
        apiStatus: 2,
        attribute1: "",
        attribute2: "",
        attribute3: "",
        balance: 0,
        bankAccount: "",
        bankCode: "",
        bankName: "",
        bankQrStatus: 2,
        bankTransferStatus: 2,
        createBy: "",
        createDate: "",
        id: null,
        loginAccount: "",
        momoBankStatus: 2,
        password: "",
        payName: "",
        proQrStatus: 2,
        remark: null,
        serialNumber: "",
        successTodayAmount: 0,
        updateBy: "",
        updateDate: "",
        verify: null,
        minimumAmount: "",
        maximumAmount: "",
        payType: 1,
        momoBankStatus: 2,
        zaloBankStatus: 2,
        vtpayBankStatus:2,
        patchGoogleCode: "",
        ownerMerchantNo: [],
      },
      connectionStatusOption: this.$t("device.add_connectionStatusOption"),
      statusOption: this.$t("device.statusOption"),
      bankTransferCodes: [],
      isdisable: false,
    };
  },
  computed: {
    payTypeOption() {
      return [
      {
          value: 1,
          label: 'APP',
        },
        {
          value: 2,
          label: 'WEB',
        },
      ]
    }

  },
  created() {
    this.formRules = {
      ref: "form",
      "label-width": "auto",
      inline: false,
      size: "small",
      rules: {
        serialNumber: [{
          required: true,
          message: this.$t("device.rules.serialNumber"),
          trigger: "blur"
        }],

        phone: [{
          required: true,
          message: this.$t("device.rules.phone"),
          trigger: "change"
        }],
        connectionStatus: [{
          required: true,
          message: this.$t("device.rules.connectionStatus"),
          trigger: "change"
        }],
        limits: [{
          required: true,
          message: this.$t("device.rules.limits"),
          trigger: "blur"
        }],
        monthLimits: [{
          required: true,
          message: this.$t("channel.rules.monthLimits"),
          trigger: "change"
        }],
        patchGoogleCode: [{
          required: true,
          message: this.$t('merchantdeposit.rules.googleDynamicCaptcha.required'),
          trigger: 'blur'
        }]
      }
    };
    this.handleEditor = debounce(this._handleEditor, 300);
  },
  methods: {
    init(row) {
      this.getBankCode();
      this.dialogVisible = true;
      if (row) {
      
        // 初始化表单数据

        Object.keys(this.form).forEach((key) => {
          if (row[key] === 0 || row[key]) {
            if (key === 'ownerMerchantNo') {
              // 字符串转数组
              this.form[key] = row[key] ? row[key].split(',') : [];
            } else {
              this.form[key] = row[key];
            }
          }
        });
        this.isdisable = true;
        this.form.id = row.id;
      }else {
        this.handleEmpty()
        this.isdisable = false;
      }
    },

    async getBankCode() {
      const { data: { data: res } } = await channelApi.confType();
      this.bankTransferCodes = res["bank_transfer"].map(code => ({ label: code, value: code }));
    },

    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        apiStatus: 2,
        attribute1: "",
        attribute2: "",
        attribute3: "",
        balance: 0,
        bankAccount: "",
        bankCode: "",
        bankName: "",
        bankQrStatus: 2,
        bankTransferStatus: 2,
        createBy: "",
        createDate: "",
        id: null,
        loginAccount: "",
        momoBankStatus: 2,
        password: "",
        payName: "",
        proQrStatus: 2,
        remark: null,
        serialNumber: "",
        successTodayAmount: 0,
        updateBy: "",
        updateDate: "",
        verify: null,
        minimumAmount: "",
        maximumAmount: "",
        payType: 1,
        momoBankStatus: 2,
        zaloBankStatus: 2,
        vtpayBankStatus:2,
        patchGoogleCode: "",
        ownerMerchantNo: [],
      };
    },

    handelCancel() {
        this.dialogVisible = false
        this.handleEmpty()
    },
    _handleEditor() {
      this.$refs.form.validate(
        (valid) =>
          valid &&
          this.$emit(this.isAdd ? "doConfAdd" : "doConfUpdate", this.form, () => {
            this.dialogVisible = false;
          })
      );
    }
  }
};

</script>

<style scoped>
 .dialog-footer {
  margin-left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/device/editorBank.vue